import { isLowercaseAtsError, isUppercaseAtsError } from './ats-error';
import { HttpClientError } from './http-client';

export async function toJSON<T>(res: Response) {
  if (res.ok === false) {
    const errorOptions = await getErrorOptions(res);
    throw new HttpClientError(errorOptions);
  }

  if (res.status === 204) {
    return noContent as unknown as T;
  }

  return res.json() as unknown as T;
}

async function getErrorOptions(response: Response) {
  const data = await response.json();

  if (isLowercaseAtsError(data)) {
    return {
      code: data.code,
      message: data.message,
      description: data.description,
      status: response.status,
    };
  }

  if (isUppercaseAtsError(data)) {
    return {
      code: data.Code,
      message: data.Message,
      status: response.status,
    };
  }

  return {
    code: 'unknown',
    message: await statusText(response),
    description: `Unknown error: ${response.statusText}`,
    status: response.status,
  };
}

async function statusText(response: Response) {
  switch (response.status) {
    case 500:
      return 'Internal server error';
    case 401:
      return 'Unauthorized';
    case 403:
      return 'Forbidden';
    case 404:
      return 'Not found';
    default:
      return response.statusText.length > 0 ? response.statusText : 'Unknown error';
  }
}

function noContent() {
  return new Proxy(
    {},
    {
      get() {
        throw new HttpClientError({ code: 'no_content', status: 204, message: 'No content' });
      },
    },
  );
}
